import React from 'react';
import Auth0ProviderWithNavigate from './auth0-provider-with-navigate.component';
export const AuthProvider = ({ children }) => (<React.Fragment>
      <Auth0ProviderWithNavigate>
        {children}
      </Auth0ProviderWithNavigate>
    </React.Fragment>);
export default AuthProvider;
